import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { useRef } from 'react';

/**
 * Generates an effectively unique ID
 *
 * @see https://stackoverflow.com/a/2117523
 */
function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    // eslint-disable-next-line no-bitwise
    var r = Math.random() * 16 | 0;
    // eslint-disable-next-line no-bitwise
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

/**
 * @deprecated Please import useId from `@applyboard/crystal-ui` instead
 */
export function useId() {
  var idRef = useRef(null);
  if (!idRef.current) {
    idRef.current = uuidv4().replace(/-/g, '');
  }
  return idRef.current;
}